import {
  TRANSACTIONS_GET,
  TRANSACTIONS_GET_MORE,
  TRANSACTIONS_SET,
  TRANSACTIONS_SET_MORE,
  TRANSACTIONS_RESET_PAGE,
  TRANSACTIONS_SET_ACTIVE_MERCHANT,
  TRANSACTIONS_ERROR,
  GET_TRANSACTIONS_INFO_DOWNL_REQUEST,
  GET_TRANSACTIONS_INFO_DOWNL_SUCCESS,
  GET_TRANSACTIONS_INFO_DOWNL_ERROR,
  GET_ADMIN_TRANSACTIONS_INFO_DOWNL_REQUEST,
  GET_ADMIN_TRANSACTIONS_INFO_DOWNL_SUCCESS,
  GET_ADMIN_TRANSACTIONS_INFO_DOWNL_ERROR,
  GET_TRANSACTION_NOTIFICATIONS_REQUEST,
  GET_TRANSACTION_NOTIFICATIONS_SUCCESS,
  GET_TRANSACTION_NOTIFICATIONS_ERROR,
  SET_SOCKET_NEW_NOTIFICATION,
  GET_ADDRESS_BOOK_LIST_REQUEST,
  GET_ADDRESS_BOOK_LIST_SUCCESS,
  GET_ADDRESS_BOOK_LIST_ERROR,
  PATCH_TRANSACTION_NOTIFICATIONS_ERROR
} from '../actions/transactions';

export default function reducer(
  state = {
    data: [],
    countItem: null,
    merchantId: '',
    fetching: true,
    loadMoreFetching: false,
    page: 1,
    pages: null,
    error: null,
    download: { fetching: false, error: null },
    adminDownload: { fetching: false, error: null },
    notifications: { entities: [], pages: 1, page: 1, fetching: false, isNew: false },
    addressBookList: { page: 1, pages: 1, fetching: false, entities: [] },
    notificationsChangeError: true
  },
  action
) {
  switch (action.type) {
    case TRANSACTIONS_GET:
      return {
        ...state,
        fetching: action.fetching,
      };
    case PATCH_TRANSACTION_NOTIFICATIONS_ERROR:
      return {
        ...state,
        notificationsChangeError: action.payload
      }
    case GET_ADDRESS_BOOK_LIST_REQUEST:
      return {
        ...state,
        addressBookList: {
          ...state.addressBookList,
          fetching: true,
        }
      }
    case GET_ADDRESS_BOOK_LIST_ERROR:
      return {
        ...state,
        addressBookList: {
          ...state.addressBookList,
          fetching: false,
        }
      }
    case GET_ADDRESS_BOOK_LIST_SUCCESS:
      return {
        ...state,
        addressBookList: {
          ...state.addressBookList,
          page: action.payload.page,
          pages: action.payload.pages,
          entities: action.payload.entities,
          fetching: false,
        }
      }
    case GET_TRANSACTION_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          fetching: true
        }
      }
    case GET_TRANSACTION_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          entities: action.payload.page === 1 ? action.payload.entities : [...state.notifications.entities, ...action.payload.entities],
          pages: action.payload.pages,
          page: action.payload.page,
          fetching: false
        }
      }
    case SET_SOCKET_NEW_NOTIFICATION:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isNew: action.payload
        }
      }
    case GET_TRANSACTION_NOTIFICATIONS_ERROR:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          entities: [],
          fetching: false
        }
      }
    case TRANSACTIONS_GET_MORE:
      return {
        ...state,
        loadMoreFetching: action.loadMoreFetching,
      };
    case TRANSACTIONS_SET:
      return {
        ...state,
        data: action.payload.entities,
        countItem: action.payload.countItem,
        fetching: action.fetching,
        page: action.payload.page,
        pages: action.payload.pages,
      };
    case TRANSACTIONS_SET_MORE:
      return {
        ...state,
        data: [...state.data, ...action.payload.entities],
        countItem: action.payload.countItem,
        loadMoreFetching: action.loadMoreFetching,
        page: action.payload.page,
        pages: action.payload.pages,
      };
    case TRANSACTIONS_RESET_PAGE:
      return {
        ...state,
        page: 1,
        pages: null,
      };
    case TRANSACTIONS_SET_ACTIVE_MERCHANT:
      return {
        ...state,
        merchantId: action.payload,
      };
    case TRANSACTIONS_ERROR:
      return {
        ...state,
        fetching: false,
      };
    case GET_TRANSACTIONS_INFO_DOWNL_REQUEST:
      return {
        ...state,
        download: { ...state.download, fetching: true },
      };
    case GET_TRANSACTIONS_INFO_DOWNL_SUCCESS:
      return {
        ...state,
        download: { ...state.download, fetching: false },
      };
    case GET_TRANSACTIONS_INFO_DOWNL_ERROR:
      return {
        ...state,
        download: { ...state.download, fetching: false, error: true },
      };
    case GET_ADMIN_TRANSACTIONS_INFO_DOWNL_REQUEST:
      return {
        ...state,
        adminDownload: { ...state.adminDownload, fetching: true },
      };
    case GET_ADMIN_TRANSACTIONS_INFO_DOWNL_SUCCESS:
      return {
        ...state,
        adminDownload: { ...state.adminDownload, fetching: false },
      };
    case GET_ADMIN_TRANSACTIONS_INFO_DOWNL_ERROR:
      return {
        ...state,
        adminDownload: { ...state.adminDownload, fetching: false, error: true },
      };
    default:
      return state;
  }
}
